import React from "react";
import "./Footer.css";
import logo from "../logo11.jpeg";
import { Phone, MapPin,Mail } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="footer-container">
        <div className="footer-grid">
          
          {/* Brand Column */}
          <div className="footer-column brand-col">
            <img src={logo} alt="View Secure Technologies" className="footer-logo" />
            <p className="footer-description">
              Chennai's most trusted credit card swiping service. Instant cash, 
              lowest rates, and premium service since 2016.
            </p>
          </div>

          {/* Links Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><a href="#services">Our Services</a></li>
              <li><a href="#locations">Locations</a></li>
              <li><a href="#contact">Contact Us</a></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="footer-column">
            <h3 className="footer-heading">Contact Info</h3>
            <div className="footer-contact-info">
              <div className="contact-item">
                <Phone size={16} className="contact-icon" />
                <span>9884135738 / 6385417845</span>
              </div>
             <div className="contact-item">
  <Mail className="contact-icon" />
  <span>QUICKSWIPE.CHENNAI@GMAIL.COM</span>
</div>
              <div className="contact-item">
                <MapPin size={16} className="contact-icon" />
                <span className="location-list">
                  Velachery, Jafferkhanpet, Pallavaram, Thiruvanmiyur, Arumbakkam, Vadapalani, Besant nagar
                </span>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright-text">
              © {currentYear} View Secure Technologies. All rights reserved.
            </p>
            <p className="tagline">
              Chennai's Most Trusted Credit Card Services
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;